<template>
	<div class="table-responsive">
		<table>
			<thead>
				<tr>
					<th>Provider Type</th>
					<th>URL Slug</th>
					<th>Count</th>
					<th>Actions</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="providerType in providerTypeList">
					<td>{{ providerType.name }}</td>
					<td>{{ providerType.slug }}</td>
					<td>{{ providerType.count }}</td>
					<td class="nowrap">
						<a :href="'/' + selectedSite.slug + '/provider-types/' + providerType.id + '/edit'" class="btn btn-icon btn-primary" title="Edit" v-show="userRoles.includes('provider_types.update')"><i class="fas fa-pencil-alt"></i></a>
						<a @click="deleteProviderType(providerType.id)" class="btn btn-icon btn-danger" href="#" title="Delete" v-show="userRoles.includes('provider_types.delete')"><i class="fas fa-trash-alt"></i></a>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
	export default {
		props: {
			dataProviderTypeList: {
				type: Array
			},
		},
		data() {
			return {
				providerTypeList: this.dataProviderTypeList,

				selectedSite: this.$selectedSite,
				userRoles: this.$currentUserRoles
			}
		},
		methods: {
			deleteProviderType: function (id) {
				let vm = this;

				vm.$dialog.confirm('Are you sure you want to delete this provider type?', {
					loader: true
				})
					.then((dialog) => {
						axios.delete('/api/' + vm.$selectedSite.slug + '/provider-types/' + id)
							.then(({data}) => {
								dialog.close();
								window.location.reload();
							})
							.catch(errors => {
								dialog.close();
								vm.$toastr.error('Article delete failed.', 'Error');
							});
					});
			},
		}
	}
</script>

<style scoped>

</style>
